import { themeGet } from '@styled-system/theme-get';
import { Carousel } from 'pcln-carousel';
import { Box, Button, Flex, Heading, Image } from 'pcln-design-system';
import React from 'react';
import styled from 'styled-components';
import MediaImageCard from '../MediaImageCard';
import MediaSnippet from '../MediaSnippet';
const StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "SpotlightCollection__StyledFlex",
  componentId: "sc-5nu2me-0"
})(["position:relative;gap:16px;"]);
const CarouselWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "SpotlightCollection__CarouselWrapper",
  componentId: "sc-5nu2me-1"
})(["scrollbar-width:none;", "{display:flex;overflow:scroll;align-items:center;}", "{width:75%;}"], themeGet('mediaQueries.lg'), themeGet('mediaQueries.xl'));
const StyledImage = /*#__PURE__*/styled(Image).withConfig({
  displayName: "SpotlightCollection__StyledImage",
  componentId: "sc-5nu2me-2"
})(["max-height:96px;"]);
const MAX_WIDTH_PRIMARY_LOGO = 500;
const MAX_HEIGHT_PRIMARY_LOGO = 155;
const MAX_WIDTH_MEDIA_CARD_BG_IMAGE = 400;
const MAX_HEIGHT_MEDIA_CARD_BG_IMAGE = 800;
const MAX_WIDTH_MEDIA_CARD_LOGO = 200;
const MAX_HEIGHT_MEDIA_CARD_LOGO = 160;
function transformDataToProps(item) {
  return {
    backgroundImageUrl: item.backgroundImage?.file?.url ? `${item.backgroundImage.file.url}?fm=webp&q=90&w=${MAX_WIDTH_MEDIA_CARD_BG_IMAGE}&h=${MAX_HEIGHT_MEDIA_CARD_BG_IMAGE}` : undefined,
    backgroundImageAltText: item.backgroundImage?.description,
    badgeColor: item.badgeColor,
    badgeText: item.badgeText,
    callToAction: item.callToAction,
    contentAlign: item.contentAlign,
    contentTypeId: 'mediaImageCard',
    fixedLogoSize: item.fixedLogoSize,
    isAlwaysVertical: true,
    isBadgePositionAbsolute: !item.showLogoImageBackground,
    logoImageUrl: item.logoImage?.file?.url ? `${item.logoImage.file.url}?fm=webp&q=80&w=${MAX_WIDTH_MEDIA_CARD_LOGO}&h=${MAX_HEIGHT_MEDIA_CARD_LOGO}` : undefined,
    logoImageAltText: item.logoImage?.description,
    minHeight: '500px',
    showBorder: item.showBorder,
    showLogoImageBackground: item.showLogoImageBackground,
    subheading: item.subheading,
    targetDate: item.targetDate,
    timerCopy: item.timerCopy,
    width: '100%'
  };
}
export function isMediaImageCard(content) {
  return content.contentTypeId === 'mediaImageCard';
}
export default function SpotlightCollection({
  spotlightData,
  onClickCallToAction
}) {
  const {
    heading,
    headingColor,
    logoImage,
    subheading,
    subheadingColor,
    backgroundColor,
    callToAction,
    mediaCards
  } = spotlightData;
  if (mediaCards.length === 0) return null;
  return React.createElement(StyledFlex, {
    flexDirection: ['column', null, null, null, 'row'],
    bg: backgroundColor,
    justifyContent: 'center',
    borderRadius: '2xl',
    pt: [0, null, 3],
    mx: [-3, null, 0],
    as: 'section'
  }, React.createElement(Flex, {
    width: 1,
    mx: ['auto', null, null, null, 0],
    my: 'auto',
    mt: ['24px', null, null, null, 'auto'],
    maxWidth: ['360px', null, null, null, '265px'],
    textAlign: 'center',
    flexDirection: 'column',
    style: {
      gap: '16px'
    }
  }, logoImage && React.createElement(StyledImage, {
    m: 'auto',
    src: `${logoImage.asset.file.url}?fm=webp&q=80&w=${MAX_WIDTH_PRIMARY_LOGO}&h=${MAX_HEIGHT_PRIMARY_LOGO}`,
    alt: logoImage.altText
  }), heading && React.createElement(Heading, {
    as: 'h1',
    textStyle: 'heading2',
    m: 0,
    color: headingColor
  }, heading), subheading && React.createElement(Heading, {
    as: 'h2',
    textStyle: 'paragraph2Bold',
    color: subheadingColor
  }, subheading), callToAction?.label && React.createElement(Button, {
    color: callToAction?.color,
    width: 3 / 4,
    m: 'auto',
    onClick: onClickCallToAction
  }, callToAction.label)), React.createElement(CarouselWrapper, {
    minHeight: '516px'
  }, React.createElement(Carousel, {
    arrowsPosition: 'hide',
    slideSpacing: 1,
    visibleSlides: [2.5, 2.5, 3],
    mobileVisibleSlides: [1.3, 2.5]
  }, mediaCards.map((item, index) => {
    if (isMediaImageCard(item)) {
      const mediaImageCardProps = transformDataToProps(item);
      return React.createElement(Box, {
        key: `media-image-card-wrapper${index + 1}`,
        minWidth: [null, null, '295px']
      }, React.createElement(MediaImageCard, {
        ...mediaImageCardProps
      }));
    }
    return React.createElement(MediaSnippet, {
      key: `media-snippet-${index + 1}`,
      ...item
    });
  }))));
}